import LocalizedStrings, {
  GlobalStrings,
  LocalizedStringsMethods,
} from "react-localization"
import en from "./langs/en"
import fr from "./langs/fr"

export function getCurrentLanguage(){
  return localStorage.getItem('lang') || 'fr'
}

export type IStrings = LocalizedStringsMethods & {
  [x: string]: any
}

const languages: IStrings = new LocalizedStrings({
  fr,
  en,
} as GlobalStrings<{
  [x: string]: any;
}>);

languages.setLanguage(getCurrentLanguage())

export { languages };